import React, { useState } from 'react';
import { Alert } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { updatePassword } from '../api/api';

const PasswordChangeForm = ({ showTitle = false, columnWidth = "12" }) => {
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showErrorAlert, setShowErrorAlert] = useState(false);

  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [repeatedNewPassword, setRepeatedNewPassword] = useState('');

  const [oldPasswordError, setOldPasswordError] = useState('');
  const [repeatedNewPasswordError, setRepeatedNewPasswordError] = useState('');
  const [newPasswordError, setNewPasswordError] = useState('');

  const [validated, setValidated] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setValidated(false);

    setShowSuccessAlert(false);
    setShowErrorAlert(false);

    setOldPasswordError('');
    setRepeatedNewPasswordError('');
    setNewPasswordError('');

    let isValid = true;

    if (oldPassword === '') {
      setOldPasswordError('Campo obrigatório');
      isValid = false;
    }

    if (repeatedNewPassword === '') {
      setRepeatedNewPasswordError('Campo obrigatório');
      isValid = false;
    }

    if (newPassword !== repeatedNewPassword) {
      const errorMessage = 'As senhas digitadas não coincidem.';
      setNewPasswordError(errorMessage);
      setRepeatedNewPasswordError(errorMessage);
      isValid = false;
    }

    if (newPassword === '') {
      setNewPasswordError('Campo obrigatório');
      isValid = false;
    } else if (oldPassword === newPassword) {
      setNewPasswordError('A nova senha não pode ser igual à anterior.');
      isValid = false;
    }

    if (isValid) {
      setValidated(true);

      try {
        await updatePassword(oldPassword, repeatedNewPassword, newPassword);
        setShowSuccessAlert(true);
        setValidated(false);
      } catch (error) {
        setShowErrorAlert(true);
      }

      setOldPassword('');
      setRepeatedNewPassword('');
      setNewPassword('');
      setTimeout(() => {
        setShowErrorAlert(false);
        setShowSuccessAlert(false);
      }, 3000);
    }
  };

  return (
    <div className={showTitle ? "mb-5" : ""}>
      {showTitle && <h4>Alterar Senha</h4>}
      
      {/* Success Alert */}
      {showSuccessAlert && (
        <Alert variant="success" onClose={() => setShowSuccessAlert(false)} dismissible>
          Senha atualizada com sucesso!
        </Alert>
      )}

      {/* Error Alert */}
      {showErrorAlert && (
        <Alert variant="danger" onClose={() => setShowErrorAlert(false)} dismissible>
          Erro ao atualizar senha. Verifique os campos obrigatórios.
        </Alert>
      )}

      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <Row className="mb-3">
          <Form.Group as={Col} md={columnWidth} controlId="oldPassword">
            <Form.Label>Digite sua senha atual:</Form.Label>
            <Form.Control
              required
              type="password"
              placeholder="Senha atual"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              isInvalid={oldPasswordError !== ''}
            />
            <Form.Control.Feedback type="invalid">{oldPasswordError}</Form.Control.Feedback>
          </Form.Group>
        </Row>

        <Row className="mb-3">
          <Form.Group as={Col} md={columnWidth} controlId="newPassword">
            <Form.Label>Nova senha:</Form.Label>
            <Form.Control
              required
              type="password"
              placeholder="Nova senha"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              isInvalid={newPasswordError !== ''}
            />
            <Form.Control.Feedback type="invalid">{newPasswordError}</Form.Control.Feedback>
          </Form.Group>
        </Row>

        <Row className="mb-3">
          <Form.Group as={Col} md={columnWidth} controlId="repeatedNewPassword">
            <Form.Label>Repita sua nova senha:</Form.Label>
            <Form.Control
              required
              type="password"
              placeholder="Repita sua nova senha"
              value={repeatedNewPassword}
              onChange={(e) => setRepeatedNewPassword(e.target.value)}
              isInvalid={repeatedNewPasswordError !== ''}
            />
            <Form.Control.Feedback type="invalid">{repeatedNewPasswordError}</Form.Control.Feedback>
          </Form.Group>
        </Row>

        <Button type="submit">Salvar</Button>
      </Form>
    </div>
  );
};

export default PasswordChangeForm;

